import React from 'react';
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import './Specialities.css'; // Import the CSS file for styling

const Specialities = () => {
    const surgeries = [
        {
            title: "Breast Cancer Surgery",
            description: "Breast cancer surgery aims to remove cancerous tissue from the breast while preserving as much healthy tissue as possible. Common procedures include lumpectomy, which involves removing the tumor and a small margin of surrounding tissue, and mastectomy, which involves removing the entire breast (either partially or totally).",
            link: "/learn-more"
        },
        {
            title: "Gastrointestinal Cancer Surgery",
            description: "Gastrointestinal cancer surgery focuses on treating cancers of the digestive system, including the esophagus, stomach, liver, pancreas, colon, and rectum. Procedures such as resection involve removing the tumor and affected parts of the organ, while the Whipple procedure is used for pancreatic cancer and involves removing the pancreas head, duodenum, and bile duct. ",
            link: "/learn-more"
        },
        {
            title: "Head and Neck Cancer Surgery",
            description: "Head and neck cancer surgery is used to treat cancers in the oral cavity, throat, larynx, sinuses, and salivary glands. Common procedures include tumor resection, which involves removing the tumor and affected tissues, and neck dissection, which involves removing lymph nodes in the neck if the cancer has spread.",
            link: "/learn-more"
        },
        {
            title: "Gynecologic Oncology",
            description: "Gynecologic oncology focuses on treating cancers of the female reproductive system, including ovarian, uterine, cervical, and vulvar cancers. Common procedures include hysterectomy (removal of the uterus), oophorectomy (removal of the ovaries), and debulking surgery, which involves removing as much tumor mass as possible and is often used in advanced ovarian cancer. ",
            link: "/learn-more"
        },
        {
            title: "Thoracic Oncology",
            description: "Thoracic oncology deals with cancers of the chest, including lung cancer and esophageal cancer. Common procedures include lobectomy (removal of a lobe of the lung), pneumonectomy (removal of an entire lung), and esophagectomy (removal of part or all of the esophagus).",
            link: "/learn-more"
        },
        {
            title: "Robotic and Minimally Invasive Surgery",
            description: "Robotic and minimally invasive surgery is used to perform complex surgeries with smaller incisions, reduced pain, and faster recovery times. This approach is applied in various cancer surgeries, including prostate, gynecologic, and gastrointestinal cancers.",
            image: "/assets/images/tarunlogo.png",
            link: "/learn-more"
        },
    ];

    return (


        <Grid container spacing={2} justifyContent={"center"} display={"flex"} flex="1" sx={{height:"100%", marginTop:"3px"}}>
            {surgeries.map((surgery, index) => (
                <Grid key={index} item xs={12} sm={4}>
            <Card item xs={12} sm={4}
                        sx={{
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: "100%",
                            justifyContent: 'center',
                            padding:"10px"
                        }}
                    >
                         <Typography sx={{fontSize:"20px", fontWeight:"bold"}}>{surgery.title}</Typography>
                        <CardContent>
                        {/* <img
            src="assets/images/.jpg"
            alt={surgery.title}
            style={{ width: "100%", height: "auto", borderRadius: "8px", marginBottom: "5px" }}
          /> */}
                        </CardContent>
                       
                        <Typography>{surgery.description}</Typography>
                        <a href={surgery.link} className="learn-more-link">Learn more →</a>
                    </Card>
                </Grid>

            ))}
        </Grid>
    
    );
};

export default Specialities;

